export enum PropertyType {
  None = 0,
  Portfolio = 1,
  Property = 2,
  Building = 3,
  Unit = 4,
}
